import { ExtraBenefitClaimConstants } from "../constants/ExtraBenefitClaimConstants";

export function ExtraBenefitClaim(state = {}, action) {
  switch (action.type) {
    case ExtraBenefitClaimConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };
    case ExtraBenefitClaimConstants.DIALOG_REQUEST:
      return {
        ...state,
        showDialog: action.isbool,
      };
    case ExtraBenefitClaimConstants.DIALOG_REQUEST2:
      return {
        ...state,
        showDialog2: action.isbool,
      };
    case ExtraBenefitClaimConstants.DIALOG_ISACTIVE_REQUEST:
      return {
        ...state,
        showIsActiveDialog: action.isbool,
      };
    case ExtraBenefitClaimConstants.DIALOG_ISACTIVE_REQUEST2:
      return {
        ...state,
        showIsActiveDialog2: action.isbool,
      };
    case ExtraBenefitClaimConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitClaimConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.datas,
      };

    case ExtraBenefitClaimConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitClaimConstants.GETSUBALL_REQUEST:
      return {
        ...state,
        loading2: true,
      };

    case ExtraBenefitClaimConstants.GETSUBALL_SUCCESS:
      return {
        ...state,
        subItems: action.datas,
      };

    case ExtraBenefitClaimConstants.GETSUBALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitClaimConstants.GETALL_AVAILABLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitClaimConstants.GETALL_AVAILABLE_SUCCESS:
      return {
        ...state,
        Mappseries: action.datas,
      };
    case ExtraBenefitClaimConstants.GETALL_AVAILABLE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitClaimConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case ExtraBenefitClaimConstants.CREATE_SUCCESS:
      return {
        ...state,
        items:
          state.items == null ? [action.data] : [action.data, ...state.items],
      };
    case ExtraBenefitClaimConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitClaimConstants.UPDATE_REQUEST:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId
            ? { ...item, updating: true }
            : item
        ),
      };
    case ExtraBenefitClaimConstants.UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId ? action.data : item
        ),
      };
    case ExtraBenefitClaimConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitClaimConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case ExtraBenefitClaimConstants.DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data
            ? {
                CategoryName: item.CategoryName,
                isActive: item.isActive,
              }
            : item
        ),
      };
    case ExtraBenefitClaimConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitClaimConstants.ISACTIVE_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case ExtraBenefitClaimConstants.ISACTIVE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId
            ? {
                CategoryName: item.CategoryName,
                FilePath: item.FilePath,
                TotalRows: item.TotalRows,
                IsActive: action.data.IsActive,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case ExtraBenefitClaimConstants.ISACTIVE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitClaimConstants.ISACTIVE2_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case ExtraBenefitClaimConstants.ISACTIVE2_SUCCESS:
      return {
        ...state,
        subItems: state.subItems.map((item) =>
          item.SubCatId === action.data.SubCatId
            ? {
                CategoryName: item.CategoryName,
                SubCategoryName: item.SubCategoryName,
                SubCateFilePath: item.SubCateFilePath,
                TotalRows: item.TotalRows,
                IsActive: action.data.IsActive,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case ExtraBenefitClaimConstants.ISACTIVE2_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitClaimConstants.GETCATEGORYDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitClaimConstants.GETCATEGORYDDL_SUCCESS:
      return {
        ...state,
        categoryddl: action.datas,
      };
    case ExtraBenefitClaimConstants.GETCATEGOYRDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // DELETE_REQUEST:

    case ExtraBenefitClaimConstants.GETSUBCATEGORYDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitClaimConstants.GETSUBCATEGORYDDL_SUCCESS:
      return {
        ...state,
        subcategoryddl: action.datas,
      };
    case ExtraBenefitClaimConstants.GETSUBCATEGOYRDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
case ExtraBenefitClaimConstants.ISACTIVE_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case ExtraBenefitClaimConstants.ISACTIVE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.UserId === action.data.UserId
            ? {
                UserId: item.UserId,
                UserName: item.UserName,
                Email: item.Email,
                MobileNo: item.MobileNo,
                CompanyId: item.CompanyId,
                CompanyName: item.CompanyName,
                RoleId: item.RoleId,
                RoleName: item.RoleName,
                IsActive: action.data.IsActive,
                TotalRows: item.TotalRows,
                Password: item.Password,
                ConfirmPassword: item.Password,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case ExtraBenefitClaimConstants.ISACTIVE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
  


    default:
      return state;
  }
}
